import { IEngagement } from "@wingspanhq/payments/dist/interfaces";

export type EngagementOption = {
  label: string;
  value: string;
};

export const selectorEngagementOptions = (
  engagements: IEngagement[]
): EngagementOption[] =>
  engagements
    .map(engagement => ({
      label: engagement.name,
      value: engagement.engagementId
    }))
    .filter(option => option.label && option.value);
